import { render } from "./PaymentFooterSticky.vue?vue&type=template&id=2094b053&ts=true"
import script from "./PaymentFooterSticky.vue?vue&type=script&lang=ts"
export * from "./PaymentFooterSticky.vue?vue&type=script&lang=ts"

import "./PaymentFooterSticky.vue?vue&type=style&index=0&id=2094b053&lang=scss"

import exportComponent from "/github/workspace/customer/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__